import React, { useEffect, useState, useCallback } from 'react';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';

import Loading from '../../components/Loading';
import getResponseErrors from '../../utils/getResponseErrors';

import { ContainerContrato } from './styles';

interface IContrato {
  ConCodigo: number;
  ConDataInicio: Date;
  ConDataFim: Date;
  ConValor: number;
  ConContrato: string;
}

type ComponentProps = {
  ConCodigo: number;
};

const Contrato: React.FC<ComponentProps> = ({ ConCodigo }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [contrato, setContrato] = useState<string>('');

  const handleHTML = useCallback((texto: string) => {
    return texto
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }, []);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IContrato>(
          `/planos/contrato/${ConCodigo}`,
        );

        setContrato(handleHTML(response.data.ConContrato));

        setTimeout(() => {
          window.print();
        }, 2000);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar dados do contrato',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, [ConCodigo, addToast, handleHTML]);

  return (
    <ContainerContrato>
      {loading && <Loading />}
      {contrato && <span dangerouslySetInnerHTML={{ __html: contrato }} />}
    </ContainerContrato>
  );
};

export default Contrato;
